
import React from "react";
import "./AddReviewerModal.css";

const AddReviewerModal = ({
  reviewerName,
  setReviewerName,
  phoneNumber,    
  setPhoneNumber,
  email,
  setEmail,
  error,
  successMsg,
  onClose,
  onSave,
}) => {
  return (
    <div className="modal-overlay-addreviewermodal">
      <div className="modal-box-addreviewermodal">
        <h3 className="modal-title-addreviewermodal">Add Reviewer</h3>
{/* <label className="label-addreviewermodal">Name</label>
<input
  type="text"
  className="input-addreviewermodal"
  value={reviewerName}
  onChange={(e) => setReviewerName(e.target.value)}
/>
<label className="label-addreviewermodal">Phone Number</label>
<input
  type="text"
  className="input-addreviewermodal"
  value={phoneNumber}
  onChange={(e) => {
    const value = e.target.value;

    // Allow ONLY numbers
    if (/^\d*$/.test(value)) {
      // Limit max 10 digits
      if (value.length <= 10) {
        setPhoneNumber(value);
      }
    }
  }}
  maxLength={10}
/> */}
{/* NAME + PHONE IN ONE ROW */}
<div className="row-addreviewermodal">
  <div className="field-addreviewermodal">
    <label className="label-addreviewermodal">Name</label>
    <input
      type="text"
      className="input-addreviewermodal"
      value={reviewerName}
      onChange={(e) => setReviewerName(e.target.value)}
    />
  </div>

  <div className="field-addreviewermodal">
    <label className="label-addreviewermodal">Phone Number</label>
    <input
      type="text"
      className="input-addreviewermodal"
      value={phoneNumber}
      onChange={(e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 10) {
          setPhoneNumber(value);
        }
      }}
      maxLength={10}
    />
  </div>
</div>

        <label className="label-addreviewermodal">Email</label>
        <input
          type="text"
          className="input-addreviewermodal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* <label className="label-addreviewermodal">Select Pipelines</label>
        <div className="pipeline-list-addreviewermodal">
          {pipelines.map((p) => (
            <div key={p._id} className="pipeline-item-addreviewermodal">
              <input
                type="checkbox"
                checked={selectedPipelines.includes(p._id)}
                onChange={() => togglePipeline(p._id)}
              />
              <span>{p.title}</span>
            </div>
          ))}
        </div> */}

        {error && (
          <p className="error-addreviewermodal">{error}</p>
        )}

        {successMsg && (
          <p className="success-addreviewermodal">{successMsg}</p>
        )}

        <div className="modal-btns-addreviewermodal">
          <button
            onClick={onSave}
            className="save-btn-addreviewermodal"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="cancel-btn-addreviewermodal"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddReviewerModal;


